import React from 'react';
import TemplateComment from './template-comment';
import { CommentsProps, ListType } from './comments.props';

const Comments = ({ list, loginHandler, replyHandler }: ListType) => {
  if (list && list?.length > 0) {
    return (
      list?.map((item: CommentsProps) => (
        <TemplateComment
          is_buyer={item?.is_buyer}
          key={`comments_${item?.id}`}
          score={item.score}
          id={item?.id}
          parent_id={item?.parent_id}
          user_name={item?.user_name}
          content={item?.content}
          created_at={item?.created_at}
          replies={item?.replies}
          loginHandler={loginHandler}
          replyHandler={replyHandler}
        />
      ))
    );
  }

  return null;
};

export default Comments;
